import { useContext } from "react";
import { UserContext } from "../providers/UserProvider";

const useMyInfo = () => {
  const user = useContext(UserContext);
  return user;
};

export default useMyInfo;
